import { Navigate, useLocation } from 'react-router-dom';
import { getRole } from './api';

/** Full-access routes: redirect content editors to News. */
export default function RequireAdmin({ children }) {
  const location = useLocation();
  if (getRole() === 'editor') {
    return <Navigate to="/admin/dashboard/news" replace state={{ from: location }} />;
  }
  return children;
}
